import { SupportedLanguage } from '@pmi.web/localization';
import { use } from 'i18next';
import { initReactI18next } from 'react-i18next';

import bg from '../assets/i18n/bg.json';
import cs from '../assets/i18n/cs.json';
import da from '../assets/i18n/da.json';
import de from '../assets/i18n/de-DE.json';
import en from '../assets/i18n/en-US.json';
import es from '../assets/i18n/es-ES.json';
import et from '../assets/i18n/et.json';
import fi from '../assets/i18n/fi.json';
import fr from '../assets/i18n/fr-FR.json';
import hu from '../assets/i18n/hu.json';
import id from '../assets/i18n/id.json';
import is from '../assets/i18n/is.json';
import it from '../assets/i18n/it-IT.json';
import ja from '../assets/i18n/ja.json';
import ko from '../assets/i18n/ko.json';
import lt from '../assets/i18n/lt.json';
import nb from '../assets/i18n/nb.json';
import nl from '../assets/i18n/nl-NL.json';
import pl from '../assets/i18n/pl.json';
import pt from '../assets/i18n/pt-PT.json';
import ro from '../assets/i18n/ro-RO.json';
import ru from '../assets/i18n/ru-RU.json';
import sv from '../assets/i18n/sv.json';
import th from '../assets/i18n/th.json';
import tr from '../assets/i18n/tr.json';
import uk from '../assets/i18n/uk.json';
import vi from '../assets/i18n/vi.json';
import zhs from '../assets/i18n/zh-Hans-CN.json';
import zht from '../assets/i18n/zh-Hant.json';

const DEFAULT_NS = '@pmi.web/react-virtual-warehouse-help';

export const i18nInstance = use(initReactI18next).createInstance({
  fallbackLng: SupportedLanguage.English,
  defaultNS: DEFAULT_NS,
  ns: DEFAULT_NS,
  resources: {
    [SupportedLanguage.Bulgarian]: { [DEFAULT_NS]: bg },
    [SupportedLanguage.ChineseSimplified]: { [DEFAULT_NS]: zhs },
    [SupportedLanguage.ChineseTraditional]: { [DEFAULT_NS]: zht },
    [SupportedLanguage.Czech]: { [DEFAULT_NS]: cs },
    [SupportedLanguage.Danish]: { [DEFAULT_NS]: da },
    [SupportedLanguage.Dutch]: { [DEFAULT_NS]: nl },
    [SupportedLanguage.Estonian]: { [DEFAULT_NS]: et },
    [SupportedLanguage.English]: { [DEFAULT_NS]: en },
    [SupportedLanguage.Finnish]: { [DEFAULT_NS]: fi },
    [SupportedLanguage.French]: { [DEFAULT_NS]: fr },
    [SupportedLanguage.German]: { [DEFAULT_NS]: de },
    [SupportedLanguage.Hungarian]: { [DEFAULT_NS]: hu },
    [SupportedLanguage.Icelandic]: { [DEFAULT_NS]: is },
    [SupportedLanguage.Indonesian]: { [DEFAULT_NS]: id },
    [SupportedLanguage.Italian]: { [DEFAULT_NS]: it },
    [SupportedLanguage.Japanese]: { [DEFAULT_NS]: ja },
    [SupportedLanguage.Korean]: { [DEFAULT_NS]: ko },
    [SupportedLanguage.Lithuanian]: { [DEFAULT_NS]: lt },
    [SupportedLanguage.Norwegian]: { [DEFAULT_NS]: nb },
    [SupportedLanguage.Polish]: { [DEFAULT_NS]: pl },
    [SupportedLanguage.Portuguese]: { [DEFAULT_NS]: pt },
    [SupportedLanguage.Romanian]: { [DEFAULT_NS]: ro },
    [SupportedLanguage.Russian]: { [DEFAULT_NS]: ru },
    [SupportedLanguage.Spanish]: { [DEFAULT_NS]: es },
    [SupportedLanguage.Swedish]: { [DEFAULT_NS]: sv },
    [SupportedLanguage.Thai]: { [DEFAULT_NS]: th },
    [SupportedLanguage.Turkish]: { [DEFAULT_NS]: tr },
    [SupportedLanguage.Ukrainian]: { [DEFAULT_NS]: uk },
    [SupportedLanguage.Vietnamese]: { [DEFAULT_NS]: vi },
  },
  keySeparator: false,
  nsSeparator: false,
  /**
   * react-i18next options
   */
  react: {
    bindI18n: 'languageChanged',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['h1', 'h2', 'p', 'ul', 'li', 'strong'],
  },
});

i18nInstance.init();
